const Footer = () => {
  return (
    <>
      <p className="footer">RockStar cottage © Copyright 2023 Maciej Waryś</p>
    </>
  );
};

export default Footer;
